import { render, staticRenderFns } from "./AddUAUCModal.vue?vue&type=template&id=6ea4db0e&"
import script from "./AddUAUCModal.vue?vue&type=script&lang=js&"
export * from "./AddUAUCModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports